import React, { useEffect, useState } from "react";
import { Drawer, Row, Spin } from "antd";
import * as notificationService from "../../service/notification/notificationService";
import NodataImgTrukker from "../../assets/images/nodata-img.svg";
import NodataImgAdeed from "../../assets/adeed/images/nodata-img.svg";
import closeIcon from "../../assets/images/closeIcon.svg";

import documentsIcon from "../../assets/images/notification-icons/document-pending-1.svg";
import verifiedIcon from "../../assets/images/notification-icons/verified.svg";
import progressIcon from "../../assets/images/notification-icons/document-pending.svg";
import expiredIcon from "../../assets/images/notification-icons/document-pending.svg";
import rejectedIcon from "../../assets/images/notification-icons/kyc-rejected.svg";
import loadIcon from "../../assets/images/notification-icons/new-loads.svg";
import winnerIcon from "../../assets/images/notification-icons/bid-winner.svg";
import orderConfirmedIcon from "../../assets/images/notification-icons/order-confirmed.svg";
import truckIcon from "../../assets/images/notification-icons/bid-detail-change.svg";
import assignmentIcon from "../../assets/images/notification-icons/bid-detail-change.svg";
import bidIcon from "../../assets/images/notification-icons/lowest-bid.svg";
import inquiryIcon from "../../assets/images/notification-icons/inquiry-allocated.svg";
import tripIcon from "../../assets/images/notification-icons/trip-status-due.svg";
import reverseLoadIcon from "../../assets/images/notification-icons/reverse-load.svg";
import inactiveIcon from "../../assets/images/notification-icons/inactive-bidding.svg";
import expirationIcon from "../../assets/images/notification-icons/load-expire-soon.svg";
import pendingActionsIcon from "../../assets/images/notification-icons/action-pending.svg";
import upgradeIcon from "../../assets/images/notification-icons/upgrade-icon.svg";
import ActNowIconTrukker from "../../assets/images/notification-icons/Act_Now.svg";
import ActNowIconAdeed from "../../assets/adeed/images/notification-icons/Act_Now.svg";
import UrgentIconTrukker from "../../assets/images/notification-icons/Urgent.svg";
import UrgentIconAdeed from "../../assets/adeed/images/notification-icons/Urgent.svg";
import ClosingSoonIconTrukker from "../../assets/images/notification-icons/Closing_soon.svg";
import ClosingSoonIconAdeed from "../../assets/adeed/images/notification-icons/Closing_soon.svg";
import WinnerReversalIconTrukker from "../../assets/images/notification-icons/Winner_Reversal.svg";
import WinnerReversalIconAdeed from "../../assets/adeed/images/notification-icons/Winner_Reversal.svg";
import ReversalIconTrukker from "../../assets/images/notification-icons/Reversal.svg";
import ReversalIconAdeed from "../../assets/adeed/images/notification-icons/Reversal.svg";

import { useTranslation } from "react-i18next";
import "./notificationsTab.scss";
import dayjs from "dayjs"; 
import moment from "moment";
import * as accountService from "../../service/home/homeService";
import { NotificationType } from "../../constants/commonConstants";
import { useNavigate } from "react-router-dom";
import { isAdeed } from "../../constants/brand";

// ADEED Freight shows its blue copies of these images (src/assets/adeed).
const NodataImg = isAdeed ? NodataImgAdeed : NodataImgTrukker;
const ActNowIcon = isAdeed ? ActNowIconAdeed : ActNowIconTrukker;
const UrgentIcon = isAdeed ? UrgentIconAdeed : UrgentIconTrukker;
const ClosingSoonIcon = isAdeed ? ClosingSoonIconAdeed : ClosingSoonIconTrukker;
const WinnerReversalIcon = isAdeed ? WinnerReversalIconAdeed : WinnerReversalIconTrukker;
const ReversalIcon = isAdeed ? ReversalIconAdeed : ReversalIconTrukker;



const Notifications = ({ visible, onClose }) => {
  const {t} = useTranslation();
  const [loading, setLoading] = useState(false);
  const [alertList, setAlertList] = useState([]);
  const [notificationPagination,setNotificationPagination]=useState({currentPage:1,totalRecords:0,totalPages:1,startIndex:0})
  const pageSize=50;
  
  const navigate = useNavigate();
  useEffect(() => {
    if (visible) {
      getAlertList(1);
    }
  }, [visible]);

  const getAlertList = (pageNum) => {
    setLoading(true);
    
    notificationService
      .getNotification(pageNum,pageSize)
      .then((res) => {
        const alerts = res.data?.data || [];
        setAlertList(alerts);
        setLoading(false);
        if(res.data?.pagination){
          setNotificationPagination({currentPage:pageNum,totalPages:res.data?.pagination?.totalPages,totalRecords:res.data?.pagination?.totalRecords})
        }
        else{
          setNotificationPagination({currentPage:1,totalRecords:0,totalPages:1,startIndex:0})
        }        
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error fetching alerts", error);
      });
  };

  const formatDate = (dateString) => {
    return dayjs(dateString).format("DD/MM//YYYY , hh:mm A");
  };
  const handleOnClickNotification=(item)=>{
    
    switch (item.type) {
      case NotificationType.DocumentsPending:
          navigate("/account");
          break;
      case NotificationType.OnboardingVerified:
          navigate("/loads");
          break;
      case NotificationType.VerificationInProgress:
          break;
      case NotificationType.KYCDocumentsExpired:
          navigate("/account",{state:{notificationType:NotificationType.KYCDocumentsExpired}});
          break;
      case NotificationType.KYCDocumentsRejected:
        navigate("/account",{state:{notificationType:NotificationType.KYCDocumentsRejected}});
          break;
      case NotificationType.NewLoadMatchingPreferences:
          navigate(`/loads/${item.data.InquiryId}`,{state:{isLoadFromPreferences:true}});
          break;
      case NotificationType.BidWinnerDeclared:
        navigate(`/my-bids/submissions/${item.data.InquiryId}`);
          break;
      case NotificationType.OrderConfirmed:
        navigate(`/orders/${item.data.OrderNumber}`);
        break;
      case NotificationType.BidDetailsChangedForTruckCount:
        navigate(`/my-bids/submissions/${item.data.InquiryId}`);
          break;
      case NotificationType.BidDetailsChangedForAssignments:
        navigate(`/my-bids/submissions/${item.data.InquiryId}`);
        break; 
      case NotificationType.LowestBidAvailable:
        navigate(`/my-bids/submissions/${item.data.InquiryId}`);
          break;
      case NotificationType.InquiryAllocated:
        navigate("/loads");
        break;
      case NotificationType.MultipleTripStatusUpdationPending:
          break;
      case NotificationType.ReverseLoadFound:
        navigate("/loads");
          break;
      case NotificationType.InactiveInBidding:
          navigate("/loads");
          break;
      case NotificationType.SavedLoadExpiration:
        navigate("/loads");
        break;  
      case NotificationType.ActionsPending:
          break
      case NotificationType.AssignmentIssue:
        navigate(`/my-bids/submissions/${item.data.InquiryId}`);
        break;

      case NotificationType.OnUnblockSupplier:
        navigate("/loads");
        break;
      case NotificationType.OnUpgradedToFleetOwnerC:
        navigate("/loads");
        break;
      case NotificationType.AutoPriorWinnerReversed:
        navigate(`/my-bids/submissions/${item.data.InquiryId}`);
        break;
      case NotificationType.AutoWinnerReversed:
        navigate(`/my-bids/submissions/${item.data.InquiryId}`);
        break;
      case NotificationType.BookmarkedClosingSoon:
        navigate(`/loads`);
        break;
      case NotificationType.SubmittedClosingSoon:
        navigate(`/my-bids/submissions`);
        break;
      case NotificationType.AcceptanceActNow:
        navigate(`/home`);
        break;
      case NotificationType.AssignmentActNow:
        navigate(`/home`);
        break;
      case NotificationType.Urgent:
        navigate(`/my-bids/submissions/${item.data.InquiryId}`);
        break;
      case NotificationType.OnInvoiceApproved:
        navigate("/earnings/invoice-upload", {
          state: {
            invoiceId: item?.data?.InvoiceId,
          },
        });
        break;
      case NotificationType.OnInvoiceRejected:
        navigate("/earnings/invoice-upload", {
          state: {
            invoiceId: item?.data?.InvoiceId,
          },
        });
        break;
      default:
          console.log("no action available");
     }
     onClose(item);
  }
  const getNotificationIcon = (notificationType) => {
    switch (notificationType) {
        case NotificationType.DocumentsPending:
            return documentsIcon;
        case NotificationType.OnboardingVerified:
            return verifiedIcon;
        case NotificationType.VerificationInProgress:
            return progressIcon;
        case NotificationType.KYCDocumentsExpired:
            return expiredIcon;
        case NotificationType.KYCDocumentsRejected:
            return rejectedIcon;
        case NotificationType.NewLoadMatchingPreferences:
            return loadIcon;
        case NotificationType.BidWinnerDeclared:
            return winnerIcon;
        case NotificationType.OrderConfirmed:
            return orderConfirmedIcon;
        case NotificationType.BidDetailsChangedForTruckCount:
            return truckIcon;
        case NotificationType.BidDetailsChangedForAssignments:
            return assignmentIcon;
        case NotificationType.LowestBidAvailable:
            return bidIcon;
        case NotificationType.InquiryAllocated:
            return inquiryIcon;
        case NotificationType.MultipleTripStatusUpdationPending:
            return tripIcon;
        case NotificationType.ReverseLoadFound:
            return reverseLoadIcon;
        case NotificationType.InactiveInBidding:
            return inactiveIcon;
        case NotificationType.SavedLoadExpiration:
            return expirationIcon;
        case NotificationType.ActionsPending:
            return pendingActionsIcon;
        case NotificationType.AssignmentIssue:
              return expirationIcon;
        case NotificationType.AutoPriorWinnerReversed:
             return WinnerReversalIcon;
        case NotificationType.AutoWinnerReversed:
             return WinnerReversalIcon;
        case NotificationType.BookmarkedClosingSoon:
             return ClosingSoonIcon;
        case NotificationType.SubmittedClosingSoon:
             return ClosingSoonIcon;
        case NotificationType.AcceptanceActNow:
             return ActNowIcon;
        case NotificationType.AssignmentActNow:
             return ActNowIcon;
        case NotificationType.Urgent:
             return UrgentIcon;
        case NotificationType.OnUnblockSupplier:
              return expiredIcon;
        case NotificationType.OnUpgradedToFleetOwnerC:
              return upgradeIcon;           
        default:
            return pendingActionsIcon;
    }
  };
    // const todayDate = moment().utc().startOf("day");

    // const todayNotifications = alertList.filter((item) =>
    //   moment(item.createdAt).utc().isAfter(todayDate)
    // );

    // const olderNotifications = alertList.filter((item) =>
    //   moment(item.createdAt).utc().isBefore(todayDate)
    // );
  

    // console.log("older" , olderNotifications);
    // console.log("today" , todayNotifications);

  return (
    <Drawer
    bodyStyle={{padding:0}}
    className="drawer-notification-wrapper"
      title={
        <div className="title-container-notification">
          <span className="section-title-notification">{t("LEFT_SIDER_NOTIFICATIONS")}</span>
          <span className="cross-img" onClick={onClose}> <img src={closeIcon} alt="No notifications" /></span>
        </div>
      }
      placement="right"
      closable={false}
      onClose={onClose}
      open={visible}
      width={510}
    
    >
      {loading ? (
        <div className="loading-container">
          <Spin />
        </div>
      ) : alertList.length > 0 ? (
        <div className="notification-list">
          <div>
          {alertList.length > 0 && (
            <>
              {/* <div className="section-title">Today</div> */}
              {alertList.map((item) => (
                <div className={`alert-card ${!item.isRead &&'pending-read'}`} key={item.id} onClick={()=>{handleOnClickNotification(item)}}>
                  <div className="alert-content">
                     <span className={`image-notifications ${!item.isRead &&'pending-read'}`}><img src={getNotificationIcon(item.type)}  alt="icon"/></span> 
                    <span className="alert-msg">{item.body}</span>
                  </div>
                  <Row className="alert-time">{formatDate(item.createdAt)}</Row>
                </div>
              ))}
            </>
          )}
          </div>
         
          {/* {olderNotifications.length > 0 && (
            <>
              <div className="section-title">Older</div>
              {olderNotifications.map((item) => (
                <div className="alert-card" key={item.id}>
                  <div className="alert-content">
                     <span className="image-notifications"><img src={verificationIcon} alt="icon"/></span> 
                    <span className="alert-msg">{item.message}</span>
                  </div>
                  <Row className="alert-time">{formatDate(item.createdAt)}</Row>
                </div>
              ))}
            </>
          )} */}
        </div>
      ) : (
        <div className="no-data-container">
          <img src={NodataImg} alt="No notifications" />
     
        </div>
      )}
    </Drawer>
  );
};

export default Notifications;
